export default __webpack_public_path__ + "static/media/image.40c5b7c1.png";